export const actions = {
  GET_INSPECTIONS_LIST: 'GET_INSPECTIONS_LIST',
  GET_INSPECTIONS_LIST_SUCCESS: 'GET_INSPECTIONS_LIST_SUCCESS',
  GET_INSPECTIONS_LIST_FAILURE: 'GET_INSPECTIONS_LIST_FAILURE',
  SET_PAGE: 'SET_PAGE',
};
